import { ifAuthenticated, hasAccess, accessWithToken, ROLES_ACCESS, hasArtPortalAccess } from '../utils';
import multiguard from 'vue-router-multiguard';
import { account } from '../../routes.account';

const artRoutes = [
  {
    path: '/art',
    name: 'art',
    component: () => import('./'),
    beforeEnter: multiguard([ifAuthenticated, hasArtPortalAccess, hasAccess]),
    meta: {
      id: ROLES_ACCESS.ARTS
    },
    children: [
      {
        path: 'proofs/:proofId',
        component: () => import('./Proofs/View')
      },
      {
        name: 'art/proofs',
        path: 'proofs',
        component: () => import('./Proofs')
      },
      {
        name: 'art/users',
        path: 'users',
        component: () => import('./Users/index'),
        meta: { id: [ROLES_ACCESS.ARTS[2]] }
      },
      {
        path: 'users/create',
        name: 'art/users/create',
        component: () => import('./Users/UserForm'),
        meta: { id: [ROLES_ACCESS.ARTS[2]] }
      },
      {
        path: 'users/:userId/edit',
        name: 'art/users/:userId/edit',
        component: () => import('./Users/UserForm'),
        meta: { id: [ROLES_ACCESS.ARTS[2]] }
      },
      ...account('art')
    ].map((el) => ({ ...el, beforeEnter: hasAccess }))
  },
  {
    path: '/art-proofs',
    name: 'art-proofs',
    component: () => import('./index'),
    beforeEnter: multiguard([accessWithToken]),
    meta: {
      id: ROLES_ACCESS.ARTS
    },
    children: [
      {
        name: 'art-proofs/item',
        path: ':proofId',
        component: () => import('./Proofs/View')
      }
    ]
  }
];
export { artRoutes as default };
